// extracted by mini-css-extract-plugin
module.exports = {"title":"PayReportsCreateModal__title--3DLZB","modal_btn":"PayReportsCreateModal__modal_btn--_xCg6","loading":"PayReportsCreateModal__loading--2MIRk"};